import React from "react"

const PlusIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 31 31">
    <g stroke="currentColor"  strokeWidth="1.8px">
      <path d="m 15.5 0 v 31" />
      <path d="m 0 15.5 h 31" />
    </g>
  </svg>
)

export default PlusIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/PlusIcon.jsx